import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @ts-ignore
import {
    Alert,
    Box,
    Button,
    Container,
    Grid,
    Paper,
    TextField,
    Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CircularProgress from '@mui/material/CircularProgress';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { useGlobalStore } from '../../../application/store/store';
import OrganizationService from './OrganizationService';
import { NavigationRoutes } from '../../../application/router/routes';
import { useSearchParams } from 'react-router-dom';

const CreateTenantOrganization = () => {
    const [searchParams] = useSearchParams();
    const [errors, setErrors] = useState<Record<string, string[]>>({});
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const setMessage = useGlobalStore((state) => state.setMessage);
    const organizationService = new OrganizationService();

    const parentId = searchParams.get('parentId');
    const parentName = searchParams.get('parentName');

    const [formData, setFormData] = useState({
        name: '',
        organizationType: '',
        parentOrgId: parentId,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            await organizationService.createOrganization(formData);
            navigate(NavigationRoutes.tenantOrganizations);
        } catch (error) {
            if (error?.response?.data?.errors) {
                setErrors(error.response.data.errors);
            }
            if (error?.response?.data?.messages) {
                setErrors({
                    CreateUserRequestValidator: error.response.data.messages,
                });
            } else {
                setMessage(
                    'Ett oväntat fel uppstod. Är namnet redan registrerat?',
                    'warning'
                );
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancel = () => {
        navigate(NavigationRoutes.tenantOrganizations);
    };

    return (
        <div>
            <Box display="flex" alignItems="center" mb={2}>
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={handleCancel}
                    color="primary"
                >
                    Tillbaka
                </Button>
            </Box>
            <Container maxWidth="sm">
                <Paper
                    elevation={3}
                    className="p-8 border-r-6"
                    component="form"
                    onSubmit={handleSubmit}
                >
                    <Typography variant="h4" align="center" gutterBottom>
                        Skapa ny Organisation
                    </Typography>
                    {Object.keys(errors).length > 0 && (
                        <Box mt={2} mb={2}>
                            {Object.values(errors).map((errorMessages, index) =>
                                errorMessages.map((message, idx) => (
                                    <Alert
                                        key={`${index}-${idx}`}
                                        severity="error"
                                        sx={{ mb: 1 }}
                                    >
                                        {message}
                                    </Alert>
                                ))
                            )}
                        </Box>
                    )}
                    <Grid container spacing={2}>
                        {[
                            { label: 'Namn', name: 'name' },
                            {
                                label: 'Organisations Typ',
                                name: 'organizationType',
                            },
                            {
                                label: 'Föräldra Organisation',
                                name: 'parentOrgId',
                                value: parentName,
                                disabled: true,
                            },
                        ].map(({ label, name, value, disabled }) => (
                            <Grid item xs={12} key={name}>
                                <TextField
                                    fullWidth
                                    label={label}
                                    name={name}
                                    value={value ?? formData[name]} // use parentName if provided, otherwise formData
                                    onChange={handleChange}
                                    variant="outlined"
                                    disabled={disabled}
                                />
                            </Grid>
                        ))}

                        <Grid item xs={12}></Grid>
                    </Grid>

                    <Button
                        startIcon={
                            isLoading ? (
                                <CircularProgress size={24} color="info" />
                            ) : (
                                <GroupAddIcon />
                            )
                        }
                        type="submit"
                        variant="contained"
                        fullWidth
                        sx={{
                            mt: 2,
                            bgcolor: 'primary.main',
                            color: 'white',
                            '&:hover': { bgcolor: 'primary.dark' },
                        }}
                    >
                        Skapa Organisation
                    </Button>
                </Paper>
            </Container>
        </div>
    );
};

export default CreateTenantOrganization;
